function clone(object) {
  return JSON.parse(JSON.stringify(object))
}

export default {
  data() {
    return {
      defaultFilter: {
        clientId: null,
        dateRange: {
          from: null,
          until: null
        }
      },
      filter: {},
      filterPreviousState: {}
    }
  },
  created() {
    this.filter = clone(Object.assign({}, this.defaultFilter, this.filterPreviousState))
    this.clientChanged()
  },
  methods: {
    dirty(field) {
      if (this.defaultFilter[field] instanceof Array) {
        return this.defaultFilter[field].join('') !== this.filter[field].join('')
      }
      return this.defaultFilter[field] !== this.filter[field]
    },
    dirtyDateRange() {
      return this.defaultFilter.dateRange.from !== this.filter.dateRange.from ||
        this.defaultFilter.dateRange.until !== this.filter.dateRange.until
    },
    resetFilter() {
      this.filter = Object.assign({}, this.defaultFilter)
      this.clientChanged()
    },
    clientChanged() {
      const client = this.$store.state.client || {id: null}
      this.filter.clientId = client.id
    },
  },
  watch: {
    '$store.state.client'() {
      this.clientChanged()
    },
  },
}
